import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { cleanLocalStorage } from "../../../utils/cleanLocalStorage";
import { useAuth } from "../../../context/AuthProvider/useAuth";
import { fetchNearbyStores, getUserAddressInCoordinates } from "./functions";
import NearbyStoreList from "../../../components/general/NearbyStoreList";
import NearbyStoresMap from "../../../components/general/NearbyStoresMap";
import BottomSheet from "../../../components/general/BottomSheet";
import PeregrinClientNavbar from "@/components/general/Navbars/ClientNavbar/PeregrinClientNavbar";
import { sharedStyles } from "@/styles/shared";

const Home = () => {
  cleanLocalStorage();

  const auth = useAuth();

  const [nearbyStores, setNearbyStores] = useState([]);

  const [map, setMap] = useState(null);
  const [userCoordinates, setUserCoordinates] = useState<
    [number, number] | null
  >(null);
  const [mapCenter, setMapCenter] = useState<[number, number]>([-8.5, -40.5]);

  const onGetUserLocationSuccess = (position) =>
    setUserCoordinates([position.coords.latitude, position.coords.longitude]);

  const onGetUserLocationError = async () => {
    const { latitude, longitude } = await getUserAddressInCoordinates(
      auth.user
    );
    setUserCoordinates([latitude, longitude]);
  };

  const getUserLocation = () => {
    if ("geolocation" in navigator)
      navigator.geolocation.getCurrentPosition(
        onGetUserLocationSuccess,
        onGetUserLocationError
      );
  };

  const loadStoreList = async () => {
    const stores = await fetchNearbyStores(
      userCoordinates[0],
      userCoordinates[1]
    );

    setNearbyStores(stores);
  };

  useEffect(() => {
    if (auth.user.id) getUserLocation();
  }, [auth.user.id]);

  useEffect(() => {
    if (userCoordinates !== null) {
      loadStoreList();
      setMapCenter(userCoordinates);
    }
  }, [userCoordinates]);

  const renderNearbyStoreList = (
    <NearbyStoreList
      stores={nearbyStores}
      userCoordinates={userCoordinates}
      mapReference={map}
    />
  );

  const renderMap = (
    <NearbyStoresMap
      stores={nearbyStores}
      userCoordinates={userCoordinates}
      mapCenter={mapCenter}
      setMap={setMap}
    />
  );

  return (
    <Box sx={{ overflow: "hidden" }}>
      <PeregrinClientNavbar />

      <Box sx={{ ...sharedStyles.horizontalContent, gap: 0 }}>
        <Box sx={{ display: { xs: "block", md: "none", lg: "none" } }}>
          <BottomSheet>{renderNearbyStoreList}</BottomSheet>
        </Box>

        <Box
          sx={{
            overflowY: "auto",
            height: "90vh",
            width: "80%",
            maxWidth: "300px",
            display: { xs: "none", md: "block", lg: "block" }
          }}
        >
          <Box sx={{ marginY: 1.5 }}>
            <Typography textAlign="center" fontWeight="bold">
              Estabelecimentos próximos
            </Typography>
          </Box>

          {renderNearbyStoreList}
        </Box>

        {renderMap}
      </Box>
    </Box>
  );
};

export default Home;
